import { render, staticRenderFns } from "./CompetencesSocioPro.vue?vue&type=template&id=5633d044&"
import script from "./CompetencesSocioPro.vue?vue&type=script&lang=js&"
export * from "./CompetencesSocioPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports